import { Button, Text } from '@/components'
import { Utility } from '@/types'
import { CheckIcon, ExternalLinkIcon, LoaderCircle } from 'lucide-react'
import { useState } from 'react'
import { match } from 'ts-pattern'
type Props = {
  utility: Utility
  url: string
  onClick?: (utility: Utility) => Promise<void>
  isConnected?: boolean
}
export default function UtilityConnectLinkRow({
  utility,
  url,
  onClick,
  isConnected = false,
}: Props) {
  const [isLoading, setIsLoading] = useState(false)
  const onButtonClick = async () => {
    setIsLoading(true)
    await onClick?.(utility)
    setIsLoading(false)
    window.location.href = url
  }
  const name = utility.name
  const logo = utility?.logo_url
  return (
    <div key={name} className="inline-flex gap-4 w-full items-center">
      {logo && <img src={logo} className="h-10 w-16 object-contain" />}
      <Text variant="body1">{name}</Text>
      <Button
        variant="chip"
        id={`connect-button-${name}`}
        className={`${
          isConnected ? 'bg-base-success' : 'bg-themed-primary'
        } text-white rounded-lg flex items-center gap-1 ml-auto w-fit z-0`}
        onClick={() => onButtonClick()}
        disabled={isConnected}
      >
        <div className="inline-flex items-center gap-2">
          {match({ isLoading, isConnected })
            .with({ isConnected: true }, () => <CheckIcon className="size-4" />)
            .with({ isLoading: true }, () => (
              <LoaderCircle className="animate-spin size-4" />
            ))
            .otherwise(() => (
              <ExternalLinkIcon className="size-4" />
            ))}
          {isConnected ? 'Connected' : 'Connect'}{' '}
        </div>
      </Button>
    </div>
  )
}
